import React, { Component } from "react";
import axios from "axios";
import Util from "../../util/util";
import { Link } from "react-router-dom";

import "./Settings.css";

import { InputAnimated } from "../../components/elements/InputAnimated";
import { SelectAnimated } from "../../components/elements/SelectAnimated";
import { TextareatAnimated } from "../../components/elements/TextareatAnimated";

class Settings extends Component {
  constructor() {
    super();
    this.state = {
      usersData: localStorage.getItem("user_data")
        ? JSON.parse(localStorage.getItem("user_data"))
        : {},
      settingsId: "",
      settingsEmail: "",
      settingsPhoneNumber: "",
      showPhoneNumber: false,
      settingsUsername: "",

      changeImage: false,
      changeImageTop: false,
      settingsImage: "",
      settingsImageTop: "",
      settingsFirstName: "",
      settingsLastName: "",
      settingsAddress: "",
      showAddress: false,
      settingsPostalCode: "",
      region_id: 0,
      city_id: 0,
      cities_list: [],
      isCompany: false,
      loading_update: false,

      settingsBusinessName: "",
      settingsBusinessJIB: "",
      settingsBusinessAddress: "",
      about_shop: "",
      working_hours: [],

      mon_from: "",
      mon_to: "",
      tue_from: "",
      tue_to: "",
      wed_from: "",
      wed_to: "",
      thu_from: "",
      thu_to: "",
      fri_from: "",
      fri_to: "",
      sat_from: "",
      sat_to: "",
      sun_from: "",
      sun_to: "",

      shop_website: "",

      settingsEmailError: "",
      settingsPhoneNumberError: "",
      settingsUsernameError: "",

      settingsFirstNameError: "",
      settingsLastNameError: "",
      settingsAddressError: "",
      settingsPostalCodeError: "",
      settingsPhoneNumberErr: "",
      cityError: "",

      settingsBusinessNameError: "",
      settingsBusinessJIBError: "",
      settingsBusinessAddressError: "",
      about_shop_error: "",
      shop_website_error: "",
      mon_from_error: "",
      mon_to_error: "",
      tue_from_error: "",
      tue_to_error: "",
      wed_from_error: "",
      wed_to_error: "",
      thu_from_error: "",
      thu_to_error: "",
      fri_from_error: "",
      fri_to_error: "",
      sat_from_error: "",
      sat_to_error: "",
      sun_from_error: "",
      sun_to_error: "",

      working_hours_array: [
        { id: "null", name: "Neradni dan", disabled: false },
        { id: "25:00", name: "Uvijek otvoreno", disabled: false },
        { id: "00:00", name: "00:00", disabled: false },
        { id: "00:30", name: "00:30", disabled: false },
        { id: "01:00", name: "01:00", disabled: false },
        { id: "01:30", name: "01:30", disabled: false },
        { id: "02:00", name: "02:00", disabled: false },
        { id: "02:30", name: "02:30", disabled: false },
        { id: "03:00", name: "03:00", disabled: false },
        { id: "03:30", name: "03:30", disabled: false },
        { id: "04:00", name: "04:00", disabled: false },
        { id: "04:30", name: "04:30", disabled: false },
        { id: "05:00", name: "05:00", disabled: false },
        { id: "05:30", name: "05:30", disabled: false },
        { id: "06:00", name: "06:00", disabled: false },
        { id: "06:30", name: "06:30", disabled: false },
        { id: "07:00", name: "07:00", disabled: false },
        { id: "07:30", name: "07:30", disabled: false },
        { id: "08:00", name: "08:00", disabled: false },
        { id: "08:30", name: "08:30", disabled: false },
        { id: "09:00", name: "09:00", disabled: false },
        { id: "09:30", name: "09:30", disabled: false },
        { id: "10:00", name: "10:00", disabled: false },
        { id: "10:30", name: "10:30", disabled: false },
        { id: "11:00", name: "11:00", disabled: false },
        { id: "11:30", name: "11:30", disabled: false },
        { id: "12:00", name: "12:00", disabled: false },
        { id: "12:30", name: "12:30", disabled: false },
        { id: "13:00", name: "13:00", disabled: false },
        { id: "13:30", name: "13:30", disabled: false },
        { id: "14:00", name: "14:00", disabled: false },
        { id: "14:30", name: "14:30", disabled: false },
        { id: "15:00", name: "15:00", disabled: false },
        { id: "15:30", name: "15:30", disabled: false },
        { id: "16:00", name: "16:00", disabled: false },
        { id: "16:30", name: "16:30", disabled: false },
        { id: "17:00", name: "17:00", disabled: false },
        { id: "17:30", name: "17:30", disabled: false },
        { id: "18:00", name: "18:00", disabled: false },
        { id: "18:30", name: "18:30", disabled: false },
        { id: "19:00", name: "19:00", disabled: false },
        { id: "19:30", name: "19:30", disabled: false },
        { id: "20:00", name: "20:00", disabled: false },
        { id: "20:30", name: "20:30", disabled: false },
        { id: "21:00", name: "21:00", disabled: false },
        { id: "21:30", name: "21:30", disabled: false },
        { id: "22:00", name: "22:00", disabled: false },
        { id: "22:30", name: "22:30", disabled: false },
        { id: "23:00", name: "23:00", disabled: false },
        { id: "23:30", name: "23:30", disabled: false },
        { id: "24:00", name: "24:00", disabled: false },
      ],

      showViberNumber: false,
      showWhatsappNumber: false,
    };
  }

  componentDidMount() {
    document.title = this.props.pageTitle;

    if (this.state.usersData.working_hours) {
      var setS = { mon_to_error: "" };
      for (var dayhour of this.state.usersData.working_hours) {
        if (dayhour.week_day == 1) {
          setS["mon_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["mon_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
        if (dayhour.week_day == 2) {
          setS["tue_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["tue_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
        if (dayhour.week_day == 3) {
          setS["wed_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["wed_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
        if (dayhour.week_day == 4) {
          setS["thu_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["thu_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
        if (dayhour.week_day == 5) {
          setS["fri_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["fri_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
        if (dayhour.week_day == 6) {
          setS["sat_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["sat_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
        if (dayhour.week_day == 7) {
          setS["sun_from"] = dayhour.start_time
            ? dayhour.start_time.substr(0, 5)
            : "null";
          setS["sun_to"] = dayhour.end_time
            ? dayhour.end_time.substr(0, 5)
            : "null";
        }
      }

      this.setState(setS);
    }

    this.setState(
      {
        settingsId: this.state.usersData.id,
        settingsImage: this.state.usersData.image,
        settingsImageTop: this.state.usersData.image_top,
        settingsEmail: this.state.usersData.email,
        settingsPhoneNumber: this.state.usersData.phone,

        settingsUsername: this.state.usersData.name,

        region_id: this.state.usersData.region_id,
        city_id: this.state.usersData.city_id,

        settingsFirstName: this.state.usersData.first_name,
        settingsLastName: this.state.usersData.last_name,
        settingsAddress: this.state.usersData.address,
        settingsPostalCode: this.state.usersData.postal_code,

        settingsBusinessName: this.state.usersData.businessName,
        settingsBusinessJIB: this.state.usersData.businessJIB,
        settingsBusinessAddress: this.state.usersData.businessAddress,
        about_shop: this.state.usersData.about,
        shop_website: this.state.usersData.website,

        showAddress: this.state.usersData.address_show,
        showPhoneNumber: this.state.usersData.phone_show,
        showViberNumber: this.state.usersData.phone_viber,
        showWhatsappNumber: this.state.usersData.phone_whatsapp,
      },
      () => {
        this.updateLocationPick();
      }
    );

    if (
      this.state.usersData.businessName ||
      this.state.usersData.businessJIB ||
      this.state.usersData.businessAddress ||
      this.state.usersData.about ||
      this.state.usersData.website
    ) {
      this.setState({ isCompany: true });
    }
  }

  updateLocationPick() {
    var mainThis = this;
    if (this.state.region_id) {
      //this.setState({city_id: this.state.usersData.city_id});
      axios
        .post(window.ajaxLink + "user/allCities", {
          region_id: this.state.region_id,
        })
        .then((res) => {
          if (
            res["data"] &&
            res["data"]["responseData"] &&
            res["data"]["responseData"]
          ) {
            mainThis.setState({ cities_list: res["data"]["responseData"] });
          }
        })
        .catch((err) => {});
    }
  }

  clearCity() {
    this.setState({ city_id: 0 });
    this.updateLocationPick();
  }

  doImageUpload = () => {
    if (this.state.changeImage || this.state.changeImageTop) {
      const formData = new FormData();
      if (this.state.changeImage) {
        formData.append("files", this.state.changeImage);
      }
      if (this.state.changeImageTop) {
        formData.append("files", this.state.changeImageTop);
      }

      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      var mainThis = this;
      axios
        .post(window.ajaxLink + "products/uploadImages", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          var img1 = mainThis.state.changeImage;
          var img2 = mainThis.state.changeImageTop;

          if (img1 && !img2) {
            mainThis.doUpdate(
              res["data"]["responseData"]["imagesList"][0],
              false
            );
          } else if (!img1 && img2) {
            mainThis.doUpdate(
              false,
              res["data"]["responseData"]["imagesList"][0]
            );
          } else if (img1 && img2) {
            mainThis.doUpdate(
              res["data"]["responseData"]["imagesList"][0],
              res["data"]["responseData"]["imagesList"][1]
            );
          } else if (!img1 && !img2) {
            mainThis.doUpdate(false, false);
          }
        })
        .catch((err) => {});
    } else {
      this.doUpdate();
    }
  };

  doUpdate = (new_image, new_image_top) => {
    // validation
    this.setState({
      settingsEmailError: "",
      settingsPhoneNumberError: "",
      settingsUsernameError: "",

      settingsFirstNameError: "",
      settingsLastNameError: "",
      settingsAddressError: "",
      settingsPostalCodeError: "",
      settingsPhoneNumberErr: "",
      locationError: "",
      cityError: "",

      settingsBusinessNameError: "",
      settingsBusinessJIBError: "",
      settingsBusinessAddressError: "",
      about_shop_error: "",
      shop_website_error: "",
      mon_from_error: "",
      mon_to_error: "",
      tue_from_error: "",
      tue_to_error: "",
      wed_from_error: "",
      wed_to_error: "",
      thu_from_error: "",
      thu_to_error: "",
      fri_from_error: "",
      fri_to_error: "",
      sat_from_error: "",
      sat_to_error: "",
      sun_from_error: "",
      sun_to_error: "",
    });

    var allValid = true;
    //email validation
    if (
      this.state.settingsEmail != "" &&
      !Util.checkParams(this.state.settingsEmail, "email")
    ) {
      this.setState({ settingsEmailError: "Email nije pravilno upisan" });
      if (allValid) {
        document.getElementById("settings_form_email").focus();
      }
      allValid = false;
    }

    //phone number validation
    if (
      this.state.settingsPhoneNumber != "" &&
      !Util.checkParams(this.state.settingsPhoneNumber, "phone")
    ) {
      this.setState({
        settingsPhoneNumberError: "Broj telefona nije pravilno upisan",
      });
      if (allValid) {
        document.getElementById("settings_form_phone").focus();
      }
      allValid = false;
    }

    if (
      this.state.settingsEmail == "" &&
      this.state.settingsPhoneNumber == ""
    ) {
      this.setState({
        settingsEmailError: "Morate unijeti ili email ili broj telefona",
        settingsPhoneNumberError: "Morate unijeti ili email ili broj telefona",
      });
      if (allValid) {
        document.getElementById("settings_form_email").focus();
      }
      allValid = false;
    }

    //username validation
    if (!Util.checkParams(this.state.settingsUsername, "username")) {
      this.setState({
        settingsUsernameError: "Korisničko ime nije pravilno upisano",
      });
      if (allValid) {
        document.getElementById("settings_form_username").focus();
      }
      allValid = false;
    }

    //first name validation
    if (!Util.checkParams(this.state.settingsFirstName, "name")) {
      this.setState({
        settingsFirstNameError: "Ime mora sadržati više od 2 karaktera",
      });
      if (allValid) {
        document.getElementById("settings_form_name").focus();
      }
      allValid = false;
    }

    // last name validation
    if (!Util.checkParams(this.state.settingsLastName, "name")) {
      this.setState({
        settingsLastNameError: "Prezime mora sadržati više od 2 karaktera",
      });
      if (allValid) {
        document.getElementById("settings_form_lastName").focus();
      }
      allValid = false;
    }

    // address validation
    if (!Util.checkParams(this.state.settingsAddress, "address")) {
      this.setState({
        settingsAddressError: "Adresa mora sadržati više od 2 karaktera",
      });
      if (allValid) {
        document.getElementById("settings_form_adress").focus();
      }
      allValid = false;
    }

    // postal code validation
    if (!Util.checkParams(this.state.settingsPostalCode, "postal")) {
      this.setState({
        settingsPostalCodeError: "Poštanski broj mora sadržati 5 cifara",
      });
      if (allValid) {
        document.getElementById("settings_form_postalCode").focus();
      }
      allValid = false;
    }

    //phone number validation
    if (
      this.state.settingsPhoneNumber != "" &&
      !Util.checkParams(this.state.settingsPhoneNumber, "phone")
    ) {
      this.setState({
        settingsPhoneNumberErr: "Broj telefona nije pravilno upisan",
      });
      allValid = false;
    }

    //location selected validation
    if (this.state.region_id < 1) {
      this.setState({ locationError: "Izaberite lokaciju" });
      if (allValid) {
        document.getElementById("settings_location").focus();
      }
      allValid = false;
    }

    //city selection validation
    if (this.state.city_id < 1) {
      this.setState({ cityError: "Izaberite grad" });
      if (allValid) {
        document.getElementById("settings_location_city").focus();
      }
      allValid = false;
    }

    // if its a company profile checking information about company
    if (this.state.isCompany == true) {
      if (!this.state.settingsBusinessName) {
        this.setState({
          settingsBusinessNameError:
            "Naziv firme mora sadržati više od 5 karaktera",
        });
        if (allValid) {
          document.getElementById("settings_form_business").focus();
        }
        allValid = false;
      }

      //business JIB validation
      if (!Util.checkParams(this.state.settingsBusinessJIB, "JIB")) {
        this.setState({
          settingsBusinessJIBError: "JIB broj nije pravilno upisan",
        });
        if (allValid) {
          document.getElementById("settings_form_jib").focus();
        }
        allValid = false;
      }

      //business address validation
      if (!Util.checkParams(this.state.settingsBusinessAddress, "address")) {
        this.setState({
          settingsBusinessAddressError:
            "Adresa mora sadržati više od 2 karaktera",
        });
        if (allValid) {
          document.getElementById("settings_form_businessAddress").focus();
        }
        allValid = false;
      }
      if (
        this.state.shop_website != "" &&
        this.state.shop_website != undefined &&
        !Util.checkParams(this.state.shop_website, "website")
      ) {
        this.setState({ shop_website_error: "Website nije pravilno upisan" });
        if (allValid) {
          document.getElementById("shop_website").focus();
        }
        allValid = false;
      }

      if (
        (this.state.mon_to != "" &&
          this.state.mon_from != "null" &&
          this.state.mon_from != "25:00" &&
          this.state.mon_from > this.state.mon_to) ||
        (this.state.mon_from != "null" && this.state.mon_to == "null")
      ) {
        this.setState({
          mon_to_error: "Nepravilno uneseno radno vrijeme",
          mon_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("monday_from").focus();
        }
        allValid = false;
      } else if (
        this.state.mon_from != "" &&
        this.state.mon_from != "null" &&
        this.state.mon_from != "25:00" &&
        this.state.mon_to == ""
      ) {
        this.setState({
          mon_to_error: "Morate unijeti oba polja",
          mon_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("monday_from").focus();
        }
        allValid = false;
      }

      if (
        (this.state.tue_to != "" &&
          this.state.tue_from != "null" &&
          this.state.tue_from != "25:00" &&
          this.state.tue_from > this.state.tue_to) ||
        (this.state.tue_from != "null" && this.state.tue_to == "null")
      ) {
        this.setState({
          tue_to_error: "Nepravilno uneseno radno vrijeme",
          tue_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("tue_from").focus();
        }
        allValid = false;
      } else if (
        this.state.tue_from != "" &&
        this.state.tue_from != "null" &&
        this.state.tue_from != "25:00" &&
        this.state.tue_to == ""
      ) {
        this.setState({
          tue_to_error: "Morate unijeti oba polja",
          tue_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("tue_from").focus();
        }
        allValid = false;
      }

      if (
        (this.state.wed_to != "" &&
          this.state.wed_from != "null" &&
          this.state.wed_from != "25:00" &&
          this.state.wed_from > this.state.wed_to) ||
        (this.state.wed_from != "null" && this.state.wed_to == "null")
      ) {
        this.setState({
          wed_to_error: "Nepravilno uneseno radno vrijeme",
          wed_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("wed_from").focus();
        }
        allValid = false;
      } else if (
        this.state.wed_from != "" &&
        this.state.wed_from != "null" &&
        this.state.wed_from != "25:00" &&
        this.state.wed_to == ""
      ) {
        this.setState({
          wed_to_error: "Morate unijeti oba polja",
          wed_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("wed_from").focus();
        }
        allValid = false;
      }

      if (
        (this.state.thu_to != "" &&
          this.state.thu_from != "null" &&
          this.state.thu_from != "25:00" &&
          this.state.thu_from > this.state.thu_to) ||
        (this.state.thu_from != "null" && this.state.thu_to == "null")
      ) {
        this.setState({
          thu_to_error: "Nepravilno uneseno radno vrijeme",
          thu_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("thu_from").focus();
        }
        allValid = false;
      } else if (
        this.state.thu_from != "" &&
        this.state.thu_from != "null" &&
        this.state.thu_from != "25:00" &&
        this.state.thu_to == ""
      ) {
        this.setState({
          thu_to_error: "Morate unijeti oba polja",
          thu_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("thu_from").focus();
        }
        allValid = false;
      }

      if (
        (this.state.fri_to != "" &&
          this.state.fri_from != "null" &&
          this.state.fri_from != "25:00" &&
          this.state.fri_from > this.state.fri_to) ||
        (this.state.fri_from != "null" && this.state.fri_to == "null")
      ) {
        this.setState({
          fri_to_error: "Nepravilno uneseno radno vrijeme",
          fri_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("fri_from").focus();
        }
        allValid = false;
      } else if (
        this.state.fri_from != "" &&
        this.state.fri_from != "null" &&
        this.state.fri_from != "25:00" &&
        this.state.fri_to == ""
      ) {
        this.setState({
          fri_to_error: "Morate unijeti oba polja",
          fri_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("fri_from").focus();
        }
        allValid = false;
      }

      if (
        (this.state.sat_to != "" &&
          this.state.sat_from != "null" &&
          this.state.sat_from != "25:00" &&
          this.state.sat_from > this.state.sat_to) ||
        (this.state.sat_from != "null" && this.state.sat_to == "null")
      ) {
        this.setState({
          sat_to_error: "Nepravilno uneseno radno vrijeme",
          sat_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("sat_from").focus();
        }
        allValid = false;
      } else if (
        this.state.sat_from != "" &&
        this.state.sat_from != "null" &&
        this.state.sat_from != "25:00" &&
        this.state.sat_to == ""
      ) {
        this.setState({
          sat_to_error: "Morate unijeti oba polja",
          sat_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("sat_from").focus();
        }
        allValid = false;
      }

      if (
        (this.state.sun_to != "" &&
          this.state.sun_from != "null" &&
          this.state.sun_from != "25:00" &&
          this.state.sun_from > this.state.sun_to) ||
        (this.state.sun_from != "null" && this.state.sun_to == "null")
      ) {
        this.setState({
          sun_to_error: "Nepravilno uneseno radno vrijeme",
          sun_from_error: "Nepravilno uneseno radno vrijeme",
        });
        if (allValid) {
          document.getElementById("working_hours_from").focus();
        }
        allValid = false;
      } else if (
        this.state.sun_from != "" &&
        this.state.sun_from != "null" &&
        this.state.sun_from != "25:00" &&
        this.state.sun_to == ""
      ) {
        this.setState({
          sun_to_error: "Morate unijeti oba polja",
          sun_from_error: "Morate unijeti oba polja",
        });
        if (allValid) {
          document.getElementById("working_hours_from").focus();
        }
        allValid = false;
      }
    }

    // ajax register
    if (allValid == true) {
      this.setState({ loading_update: true });
      var mainThis = this;
      axios.defaults.headers.common["Authorization"] =
        this.state.usersData.token;
      axios
        .post(window.ajaxLink + "user/update", {
          id: this.state.settingsId,
          email: this.state.settingsEmail,
          username: this.state.settingsUsername,
          password: this.state.settingsPassword,
          name: this.state.settingsFirstName,
          lastName: this.state.settingsLastName,
          address: this.state.settingsAddress,
          showAddress: this.state.showAddress,
          postal_code: this.state.settingsPostalCode,
          phonenumber: this.state.settingsPhoneNumber,
          showPhoneNumber: this.state.showPhoneNumber,
          showViberNumber: this.state.showViberNumber,
          showWhatsappNumber: this.state.showWhatsappNumber,
          region: this.state.region_id,
          city: this.state.city_id,
          isCompany: this.state.isCompany,
          businessName: this.state.settingsBusinessName,
          JIB: this.state.settingsBusinessJIB,
          businessAddress: this.state.settingsBusinessAddress,
          about_shop: this.state.about_shop,
          shop_website: this.state.shop_website,
          working_hours: [
            [1, this.state.mon_from, this.state.mon_to],
            [2, this.state.tue_from, this.state.tue_to],
            [3, this.state.wed_from, this.state.wed_to],
            [4, this.state.thu_from, this.state.thu_to],
            [5, this.state.fri_from, this.state.fri_to],
            [6, this.state.sat_from, this.state.sat_to],
            [7, this.state.sun_from, this.state.sun_to],
          ],
          newImage: new_image
            ? new_image
            : this.state.changeImage
            ? ""
            : this.state.settingsImage,
          newImageTop: new_image_top
            ? new_image_top
            : this.state.changeImageTop
            ? ""
            : this.state.settingsImageTop,
        })
        .then((response) => {
          if (
            response["data"] &&
            response["data"]["responseData"] &&
            response["data"]["responseData"]["id"]
          ) {
            Util.eList = [];
            Util.callback = false;
            mainThis.setState({
              usersData: response["data"]["responseData"],
              loading_update: false,
            });
            localStorage.setItem(
              "user_data",
              JSON.stringify(response["data"]["responseData"])
            );
            window.location = "/mojprofil";
          }
        })
        .catch((err) => {
          Util.handleAjaxError(err, mainThis);
          mainThis.setState({ loading_update: false });

          if (mainThis.state.settingsEmailError) {
            document.getElementById("settings_form_email").focus();
          }
          if (mainThis.state.settingsPhoneNumberError) {
            document.getElementById("settings_form_phone").focus();
          }
          if (mainThis.state.settingsUsernameError) {
            document.getElementById("settings_form_username").focus();
          }

          //mainThis.setState({settingsEmailError: 'Korisnik sa ovim emailom već postoji'});
        });
    }
  };

  updateChild = (val, callback) => {
    if (callback) {
      this.setState(val, callback);
    } else {
      this.setState(val);
    }
  };

  selectImages = async (e) => {
    if (e.target.files) {
      let img = e.target.files[0];
      this.setState({
        settingsImage: URL.createObjectURL(img),
        changeImage: img,
      });
    }
  };

  selectImages2 = async (e) => {
    if (e.target.files) {
      let img = e.target.files[0];
      this.setState({
        settingsImageTop: URL.createObjectURL(img),
        changeImageTop: img,
      });
    }
  };

  openCloseShopProfile = (checked) => {
    if (this.state.isCompany && !checked) {
      Util.showPopupDialog(
        'Pređi na "Lični" profil',
        'Da li ste sigurni da želite da pređete sa profila "Prodavnica" na "Lični" profil?',
        {
          title: "Potvrdi",
          css: "middle_popup_blue_button",
          callback: () => {
            this.closeWebShop();
          },
        },
        {
          title: "Prekini",
          css: "middle_popup_yellow_button",
          callback: () => {},
        },
        () => {},
        "warning_popup"
      );
    } else {
      this.setState({ isCompany: true });
    }
  };

  showHideAddress = () => {
    var checked = this.state.showAddress;
    checked = !checked;
    this.setState({
      showAddress: checked,
    });
  };

  showHidePhoneNumber = () => {
    var checked = this.state.showPhoneNumber;
    checked = !checked;
    this.setState({
      showPhoneNumber: checked,
    });
  };

  showViberNumber = () => {
    var checked = this.state.showViberNumber;
    checked = !checked;
    this.setState({
      showViberNumber: checked,
    });
  };

  showWhatsappNumber = () => {
    var checked = this.state.showWhatsappNumber;
    checked = !checked;
    this.setState({
      showWhatsappNumber: checked,
    });
  };

  closeWebShop = () => {
    this.setState({
      settingsBusinessName: "",
      settingsBusinessJIB: "",
      settingsBusinessAddress: "",
      about_shop: "",
      shop_website: "",
      working_hours: [],
      mon_from: "",
      mon_to: "",
      tue_from: "",
      tue_to: "",
      wed_from: "",
      wed_to: "",
      thu_from: "",
      thu_to: "",
      fri_from: "",
      fri_to: "",
      sat_from: "",
      sat_to: "",
      sun_from: "",
      sun_to: "",
      isCompany: false,
    });
  };

  render() {
    console.log(this.state.mon_from);
    console.log(this.state.mon_to);

    return (
      <div className="settings_page">
        <form onSubmit={this.doImageUpload}>
          <div
            className="settings_topImage"
            style={{
              backgroundImage: this.state.settingsImageTop
                ? "url(" + this.state.settingsImageTop + ")"
                : "",
            }}
          >
            <input
              type="file"
              className="file_upload"
              accept="image/*"
              onChange={this.selectImages2}
            />
            <div className="settings_topIcon">
              <div className="settings_topIcon_text">Promjeni pozadinu</div>
            </div>
          </div>
          <div
            className="settings_userimage"
            id="img11"
            style={{
              backgroundImage: this.state.settingsImage
                ? "url(" + this.state.settingsImage + ")"
                : "",
            }}
          >
            <input
              type="file"
              className="file_upload"
              accept="image/*"
              onChange={this.selectImages}
            />
            <div className="settings_profileIcon"></div>
          </div>
          <div className="settings_page_title">Izmjena Informacija</div>
          <div className="settings_left">
            <div className="settings_form">
              <div className="settings_form_toptitle">
                Pristupne Informacije
              </div>
              <InputAnimated
                type="email"
                id="settings_form_email"
                title="Email"
                fieldValue={this.state.settingsEmail}
                fieldName="settingsEmail"
                fieldError={this.state.settingsEmailError}
                updateChild={this.updateChild}
              />
              <InputAnimated
                type="phone"
                id="settings_form_phone"
                title="Broj Telefona"
                fieldValue={this.state.settingsPhoneNumber}
                fieldName="settingsPhoneNumber"
                fieldError={this.state.settingsPhoneNumberError}
                updateChild={this.updateChild}
              />
              <InputAnimated
                type="text"
                id="settings_form_username"
                title="Korisničko ime"
                fieldValue={this.state.settingsUsername}
                fieldName="settingsUsername"
                fieldError={this.state.settingsUsernameError}
                updateChild={this.updateChild}
              />
              <Link to="/lozinka">
                <div className="change_password_container">
                  Zamjena lozinke?
                </div>
              </Link>
              <div className="settings_form_toptitle2">
                Izmijenite Kontakt Informacije
              </div>

              <InputAnimated
                type="text"
                id="settings_form_name"
                title="Ime"
                fieldValue={this.state.settingsFirstName}
                fieldName="settingsFirstName"
                fieldError={this.state.settingsFirstNameError}
                updateChild={this.updateChild}
              />
              <InputAnimated
                type="text"
                id="settings_form_lastName"
                title="Prezime"
                fieldValue={this.state.settingsLastName}
                fieldName="settingsLastName"
                fieldError={this.state.settingsLastNameError}
                updateChild={this.updateChild}
              />
              <div className="privacy_check_container">
                <div className="privacy_input">
                  <InputAnimated
                    type="text"
                    id="settings_form_adress"
                    title="Adresa"
                    fieldValue={this.state.settingsAddress}
                    fieldName="settingsAddress"
                    fieldError={this.state.settingsAddressError}
                    updateChild={this.updateChild}
                  />
                </div>
                <div
                  className={
                    "settings_checkbox" +
                    (this.state.showAddress ? " blueType" : "")
                  }
                  onClick={this.showHideAddress}
                >
                  <div className="animated_input_settings">
                    <div className="description_address_hover">
                      Označite ukoliko želite da prikažete Vašu adresu na
                      profilu
                    </div>
                  </div>
                </div>
              </div>
              <div className="privacy_check_container">
                <div className="privacy_input">
                  <InputAnimated
                    type="phone"
                    id="settings_form_phoneNumber"
                    title="Telefon"
                    fieldValue={this.state.settingsPhoneNumber}
                    fieldName="settingsPhoneNumber"
                    fieldError={this.state.settingsPhoneNumberErr}
                    updateChild={this.updateChild}
                  />
                </div>
                <div
                  className={
                    "settings_checkbox" +
                    (this.state.showPhoneNumber ? " blueType" : "")
                  }
                  onClick={this.showHidePhoneNumber}
                >
                  <div className="animated_input_settings">
                    <div className="description_address_hover">
                      Označite ukoliko želite da prikažete Vaš telefonski broj
                      na profilu
                    </div>
                  </div>
                </div>
                <div
                  className={
                    "settings_checkbox" +
                    (this.state.showWhatsappNumber ? " blueType" : "") +
                    " additional_number"
                  }
                  onClick={this.showWhatsappNumber}
                >
                  <div className="additional_number_name">Whatsapp</div>
                </div>
                <div
                  className={
                    "settings_checkbox" +
                    (this.state.showViberNumber ? " blueType" : "") +
                    " additional_number"
                  }
                  onClick={this.showViberNumber}
                >
                  <div className="additional_number_name">Viber</div>
                </div>
              </div>
              <InputAnimated
                type="text"
                id="settings_form_postalCode"
                title="Poštanski Broj"
                fieldValue={this.state.settingsPostalCode}
                fieldName="settingsPostalCode"
                fieldError={this.state.settingsPostalCodeError}
                updateChild={this.updateChild}
              />

              <SelectAnimated
                id="settings_location"
                title="Lokacija"
                emptyText="Učitava lokacije..."
                fieldValue={this.state.region_id}
                fieldName="region_id"
                fieldError={this.state.locationError}
                updateChild={this.updateChild}
                callback={this.clearCity}
                options_list={[
                  {
                    id: "",
                    style: { color: "inherit", background: "#ccc" },
                    name: "Republika Srpska",
                    disabled: false,
                  },
                  { id: "1", name: "Banjalučka", disabled: false },
                  { id: "2", name: "Dobojsko-Bijeljinska", disabled: false },
                  { id: "3", name: "Sarajevsko-Zvornička", disabled: false },
                  { id: "4", name: "Trebinjsko-Fočanska", disabled: false },
                  {
                    id: "",
                    style: { color: "inherit", background: "#ccc" },
                    name: "Federacija BiH",
                    disabled: true,
                  },
                  { id: "5", name: "Sarajevo", disabled: false },
                  { id: "6", name: "Unsko-sanski", disabled: false },
                  { id: "7", name: "Posavski", disabled: false },
                  { id: "8", name: "Tuzlanski", disabled: false },
                  { id: "9", name: "Zeničko-dobojski", disabled: false },
                  { id: "10", name: "Bosansko-podrinjski", disabled: false },
                  { id: "11", name: "Srednjobosanski", disabled: false },
                  {
                    id: "12",
                    name: "Hercegovačko-neretvanski",
                    disabled: false,
                  },
                  { id: "13", name: "Zapadno-hercegovački", disabled: false },
                  { id: "14", name: "Livanjski", disabled: false },
                  { id: "15", name: "Distrikt Brčko", disabled: false },
                ]}
              />

              <SelectAnimated
                id="settings_location_city"
                title={
                  this.state.cities_list.length == 0
                    ? "Prvo izaberite lokaciju"
                    : "Grad"
                }
                fieldValue={this.state.city_id}
                fieldName="city_id"
                fieldError={this.state.cityError}
                updateChild={this.updateChild}
                options_list={this.state.cities_list}
              />
            </div>
          </div>
          <div className="settings_right">
            <div className="settings_form">
              <div className="settings_form_toptitle">
                Izmijenite Poslovne Informacije
              </div>
              <div className="settings_form_iscompany">
                Označite ako želite da izmijenite informacije o firmi:{" "}
                <input
                  type="checkbox"
                  name="is_business"
                  id="is_business"
                  checked={this.state.isCompany}
                  value="1"
                  onChange={(event) => {
                    this.openCloseShopProfile(event.target.checked);
                  }}
                />
              </div>

              {this.state.isCompany == true && (
                <div>
                  <InputAnimated
                    type="text"
                    id="settings_form_business"
                    title="Puni poslovni naziv"
                    placeholder='npr: Prodaja obuće "Urban Fast" s.p.'
                    fieldValue={this.state.settingsBusinessName}
                    fieldName="settingsBusinessName"
                    fieldError={this.state.settingsBusinessNameError}
                    updateChild={this.updateChild}
                  />
                  <InputAnimated
                    type="text"
                    id="settings_form_jib"
                    title="ID / JIB broj"
                    placeholder="npr: 12332211235"
                    fieldValue={this.state.settingsBusinessJIB}
                    fieldName="settingsBusinessJIB"
                    fieldError={this.state.settingsBusinessJIBError}
                    updateChild={this.updateChild}
                  />
                  <InputAnimated
                    type="text"
                    id="settings_form_businessAddress"
                    title="Poslovna adresa firme"
                    placeholder="npr: Sarajevska 7, Sarajevo, 71000"
                    fieldValue={this.state.settingsBusinessAddress}
                    fieldName="settingsBusinessAddress"
                    fieldError={this.state.settingsBusinessAddressError}
                    updateChild={this.updateChild}
                  />
                  <InputAnimated
                    type="text"
                    id="shop_website"
                    title="Website"
                    fieldValue={this.state.shop_website}
                    fieldName="shop_website"
                    fieldError={this.state.shop_website_error}
                    updateChild={this.updateChild}
                  />
                  <TextareatAnimated
                    id="about_shop"
                    title="O radnji"
                    resize="vertical"
                    fieldValue={this.state.about_shop}
                    fieldError={this.state.about_shop_error}
                    fieldName="about_shop"
                    updateChild={this.updateChild}
                  />
                  <div className="settings_form_toptitle2">Radni dani:</div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="monday_from"
                        title="Ponedjeljak:"
                        fieldValue={this.state.mon_from}
                        fieldName="mon_from"
                        fieldError={this.state.mon_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.mon_from &&
                      this.state.mon_from != "null" &&
                      this.state.mon_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="monday_to"
                            title="Do"
                            fieldValue={this.state.mon_to}
                            fieldName="mon_to"
                            fieldError={this.state.mon_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="tue_from"
                        title="Utorak:"
                        fieldValue={this.state.tue_from}
                        fieldName="tue_from"
                        fieldError={this.state.tue_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.tue_from &&
                      this.state.tue_from != "null" &&
                      this.state.tue_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="tue_to"
                            title="Do"
                            fieldValue={this.state.tue_to}
                            fieldName="tue_to"
                            fieldError={this.state.tue_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="wed_from"
                        title="Srijeda:"
                        fieldValue={this.state.wed_from}
                        fieldName="wed_from"
                        fieldError={this.state.wed_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.wed_from &&
                      this.state.wed_from != "null" &&
                      this.state.wed_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="wed_to"
                            title="Do"
                            fieldValue={this.state.wed_to}
                            fieldName="wed_to"
                            fieldError={this.state.wed_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="thu_from"
                        title="Četvrtak:"
                        fieldValue={this.state.thu_from}
                        fieldName="thu_from"
                        fieldError={this.state.thu_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.thu_from &&
                      this.state.thu_from != "null" &&
                      this.state.thu_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="thu_to"
                            title="Do"
                            fieldValue={this.state.thu_to}
                            fieldName="thu_to"
                            fieldError={this.state.thu_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="fri_from"
                        title="Petak:"
                        fieldValue={this.state.fri_from}
                        fieldName="fri_from"
                        fieldError={this.state.fri_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.fri_from &&
                      this.state.fri_from != "null" &&
                      this.state.fri_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="fri_to"
                            title="Do"
                            fieldValue={this.state.fri_to}
                            fieldName="fri_to"
                            fieldError={this.state.fri_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="sat_from"
                        title="Subota:"
                        fieldValue={this.state.sat_from}
                        fieldName="sat_from"
                        fieldError={this.state.sat_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.sat_from &&
                      this.state.sat_from != "null" &&
                      this.state.sat_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="sat_to"
                            title="Do"
                            fieldValue={this.state.sat_to}
                            fieldName="sat_to"
                            fieldError={this.state.sat_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                  <div className="woriking_hours_container">
                    <div className="woriking_hours_inline mr4">
                      <SelectAnimated
                        id="working_hours_from"
                        title="Nedjelja:"
                        fieldValue={this.state.sun_from}
                        fieldName="sun_from"
                        fieldError={this.state.sun_from_error}
                        updateChild={this.updateChild}
                        options_list={this.state.working_hours_array}
                      />
                    </div>
                    {this.state.sun_from &&
                      this.state.sun_from != "null" &&
                      this.state.sun_from != "25:00" && (
                        <div className="woriking_hours_inline">
                          <SelectAnimated
                            id="working_hours_to"
                            title="Do"
                            fieldValue={this.state.sun_to}
                            fieldName="sun_to"
                            fieldError={this.state.sun_to_error}
                            updateChild={this.updateChild}
                            options_list={this.state.working_hours_array}
                          />
                        </div>
                      )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div
            className={
              "loader_holder" + (this.state.loading_update ? " active" : "")
            }
          >
            <div className="loader_big"></div>
          </div>
          <div className="settings_button" onClick={this.doImageUpload}>
            Sačuvaj
          </div>
        </form>
      </div>
    );
  }
}

export default Settings;
